export default {
  selectTicketType: 'Select Ticket Type',
  confirmTicketDetails: 'Confirm Ticket Details',
  payment: 'Payment',
  receiveETicket: 'Receive E-Ticket',
  exhibitionTickets: 'Exhibition Tickets',
  viewExhibitions: 'View Exhibitions',
  exhibitionDates: 'Exhibition Dates',
  viewMap: 'View Map',
  organizer: 'Organizer',
  venue: 'Venue',
  hallNumber: 'Hall Number',
  venueAddress: 'Venue Address',
  ticketType: 'Ticket Type',
  eTicket: 'E-Ticket',
  fullEventPass: 'Full Event Pass',
  singleDayTicket: 'Single-Day Ticket',
  freeAdmission: 'Free Admission',
  limitedTimeOffer: 'Limited Time Offer',
  soldOut: 'Sold Out',
  discounted: 'Discounted',
  RMB: 'RMB',

  // Price related
  priceTitle: 'Pricing',
  ticketPrice: 'Ticket',
  serviceFee: 'Svc. Fee',
  vat: 'VAT',
  promotion: 'Promo',
  totalAmount: 'Total',
  limitedTimeFree: 'Free(LTO)',
  feeInclusion: '(Inc. VAT & Fee)',

  // Payment related
  modifyOrder: 'Modify Order',
  alipay: 'Alipay',
  wechatPay: 'WeChat Pay',
  redirectToAlipay: "Click 'Proceed to Pay' to redirect to Alipay",
  scanWechatQR: "Click 'Proceed to Pay' to scan QR code via WeChat",
  proceedToPay: 'Proceed to Pay',
  paymentSecurity: 'Juzhan Payment Security Commitment',
  wechatScanPayment: "Open WeChat 'Scan' to scan the QR code for payment",

  // Form related
  selectCompanyIndividual: 'Select Company/Individual',
  company: 'Company',
  individual: 'Individual',
  companyName: 'Company Name',
  attendeeName: 'Name',
  companyNameInput: 'Enter Company Name',
  nameInput: 'Enter Name',
  confirmButton: 'Confirm',
  cancelButton: 'Cancel',

  // Visitor management
  visitor: 'Visitor',
  addVisitor: 'Add Visitor',
  addAttendee: 'Add Attendee',
  fullName: 'Full Name',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  jobTitle: 'Job Title',
  mobileNumber: 'Mobile Number',
  email: 'Email',
  idType: 'ID Type',
  idNumber: 'ID Number',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',

  // ID types
  idCard: 'ID No',
  passport: 'PP No',
  hkMacaoPass: 'HMP No',
  taiwanPass: 'TAP No',

  // Ticketing terms
  ticketingTerms: 'Ticketing Terms',
  agreeSubmit: 'Confirm',
  ticketGuidelines:
    'After successful ticket purchase, access the website/app to display your ticket QR code. Carry the original ID used during purchase for entry verification. Final venue details are subject to on-site arrangements.',
  entryInstructions:
    'After successful ticket booking, please bring the original ID card of the visitor for swipe entry or exchange for a paper pass at the on-site service counter.',
  entryProcedure:
    'After successful ticket booking, please bring the original passport of the visitor and the e-ticket to the on-site service counter or self-service kiosk to exchange for an entry pass.',

  // Important notes
  notes: 'Important Notes',
  preRegistrationTickets: 'Pre-Registration',
  visitorRealNameSystem:
    '{num}.Real-Name Entry: Required for entry (use the same ID as your ticket).',
  bookingPurpose:
    '{num}.Confirmation: Save time – get your entry pass via SMS/WeChat/email after booking.',
  ticketStatus: 'Ticket Availability',
  bookingStatus: 'Tickets are unavailable if: Booking hasn’t started yet.',
  bookingClosed: 'Booking has closed.',
  refundPolicy2: 'No Refunds',
  ticketNature:
    'Tickets cannot be refunded or exchanged (legally classified as time-sensitive “securities”).',
  realNamePolicy: 'Real-Name Policy Notice',
  ticketingRule:
    'All tickets require ID-bound registration. Visitors must present the original ID document used during purchase for verification at entry.',

  // Ticket type descriptions
  deliveryMethod:
    'E-Ticket Delivery：No physical tickets needed. Check “My Tickets” after payment to access your e-ticket.',
  precautions:
    'Important Notes：All ticket times use the exhibition’s local time. On the last day, enter before 14:00.'
}
